import * as m from "../es2015/charts";
window.am4charts = m;


//////////////////
// WEBPACK FOOTER
// ./charts.js
// module id = 319
// module chunks = 4